<template>
	<NewItem
		ref="newItem"
		button-title="New Category"
	>
		<template slot="form">
			<CategoryForm
				:existing-categories="existingCategories"
				:archived-categories="archivedCategories"
				@new="$refs.newItem.show = false"
			>
				<v-btn
					slot="buttons"
					flat
					color="error"
					@click="$refs.newItem.show = false"
				>
					close
				</v-btn>
			</CategoryForm>
		</template>
	</NewItem>
</template>

<script>
import NewItem from '@/components/NewItem';
import CategoryForm from '@/components/Report/CategoryForm';

export default {
	components: {
		NewItem,
		CategoryForm,
	},
	props: {
		existingCategories: { type: Array, default: () => [] },
		archivedCategories: { type: Array, default: () => [] },
	},
};
</script>

<style>

</style>
